import { EmailData } from "./types";

export function getDefaultState(): EmailData {
    return {
		emailsStorage: {},
		eventRecordIdToShowEmailFor: -1,
    }
}
